export default "__VITE_ASSET__BrReGfFw__"